<template>
    <div class="miniText" :style="style">
        <slot/>
    </div>
</template>
<script>
export default {
    props:{
        style:{
            default:''
        }
    }
}
</script>
<style lang="scss" scoped>
.miniText{
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: #C3C7CE;
    line-height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/userCenter/companyCertificate/components/miniIntroText.vue